/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CaseSystemTrigger {
  CERTIFICATE_LIABILITY_INSURANCE_INVALID = 'certificate_liability_insurance_invalid',
  CERTIFICATE_CARGO_INSURANCE_INVALID = 'certificate_cargo_insurance_invalid',
}
